// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockUser_wrapper__2TcSJ"};